var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.58631 14.2788C5.36575 16.0478 8.46904 18.4999 11.9997 18.4999C15.5303 18.4999 18.6331 16.0478 20.4125 14.2788C20.8818 13.8123 21.1172 13.5782 21.2667 13.1201C21.3733 12.7933 21.3733 12.2067 21.2667 11.8799C21.1172 11.4218 20.8818 11.1877 20.4125 10.7211C18.633 8.95208 15.5303 6.5 11.9997 6.5C8.46904 6.5 5.36575 8.95208 3.58631 10.7211C3.11665 11.188 2.8818 11.4216 2.73231 11.8799C2.62569 12.2067 2.62569 12.7933 2.73231 13.1201C2.8818 13.5784 3.11665 13.8119 3.58631 14.2788Z",
    stroke: "#434343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99951 12.5C9.99951 13.6046 10.8949 14.5 11.9995 14.5C13.1041 14.5 13.9995 13.6046 13.9995 12.5C13.9995 11.3954 13.1041 10.5 11.9995 10.5C10.8949 10.5 9.99951 11.3954 9.99951 12.5Z",
    stroke: "#434343",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowIcon);
export default __webpack_public_path__ + "static/media/showIcon.979bcf6b08a85c4f657a628056c34bcc.svg";
export { ForwardRef as ReactComponent };